/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import React, {useState, useEffect} from 'react';
import {StyleSheet, View} from 'react-native';
import {ElementBox, Element, countElementSize} from '@components/frame';
import ColorWrapper from '@styles/colors';

import { isPhone} from '@helpers';

const WrappContent = (props) => {
  const {scale, C} = props;
  const bigRectangleSize = countElementSize(
    isPhone
      ? {left: 72, right: 72, top: 212, bottom: 212}
      : {
          top: 252,
          bottom: 252,
          right: 432,
          left: 432,
        },
  );
  const medRectangleSize = countElementSize(
    isPhone
      ? {left: '30%', right: '30%', top: '38.75%', bottom: '38.75%'}
      : {
          left: '43.33%',
          right: '43.33%',
          top: '40%',
          bottom: '40%',
        },
  );

  const CenterElement = () => {
    return (
      <View>
        <Element
          {...{
            config: {
              verticalCenter: 0,
              horizontalCenter: 0,
              width: 28,
              height: 28,
              parentWidth: scale(72),
              parentHeight: scale(72),
              borderRadius: scale(3),
              border: {
                borderStyle: 'dashed',
                borderWidth: StyleSheet.hairlineWidth,
                borderRadius: scale(3),
                borderColor: C('Gray / Light / 4'),
              },
            },
          }}
        />
        <Element
          {...{
            config: {
              verticalCenter: 0,
              horizontalCenter: 0,
              width: 20,
              height: 2,
              parentWidth: scale(72),
              parentHeight: scale(72),
              backgroundColor: C('Gray / Light / 1'),
            },
          }}
        />
        <Element
          {...{
            config: {
              verticalCenter: 0,
              horizontalCenter: 0,
              width: 2,
              height: 20,
              parentWidth: scale(72),
              parentHeight: scale(72),
              backgroundColor: C('Gray / Light / 1'),
            },
          }}
        />
      </View>
    );
  };
  const LineElement = ({bg, pos}) => {
    const position = (() => {
      switch (pos) {
        case 'top':
          return {position: {top: 5}, horizontalCenter: 0};
        case 'left':
          return {position: {left: 5}, verticalCenter: 0};
        case 'bottom':
          return {position: {bottom: 5}, horizontalCenter: 0};
        case 'right':
          return {position: {right: 5}, verticalCenter: 0};
      }
    })();

    const size = (() => {
      switch (pos) {
        case 'top':
          return {width: 2, height: 12};
        case 'left':
          return {width: 12, height: 2};
        case 'bottom':
          return {width: 2, height: 12};
        case 'right':
          return {width: 12, height: 2};
      }
    })();

    return (
      <Element
        {...{
          config: {
            ...position,
            ...size,
            parentWidth: scale(72),
            parentHeight: scale(72),
            backgroundColor: bg,
          },
        }}
      />
    );
  };

  return (
    <ElementBox>
      {/* <View style={{borderRaius}} /> */}
      <Element
        {...{
          config: {
            position: {
              top: 162,
              left: 18,
            },
            width: 72,
            height: 72,
            borderRadius: scale(3.4),
            border: {
              borderRadius: scale(3.4),
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: C('Gray / Light / 4'),
            },
            backgroundColor: C('Overlay / Dark / Picture white'),
          },
        }}>
        <LineElement {...{bg: C('Link / Light / Blue'), pos: 'top'}} />
        <LineElement {...{bg: C('Link / Light / Blue'), pos: 'left'}} />
        <LineElement {...{bg: C('Gray / Light / 1'), pos: 'bottom'}} />
        <LineElement {...{bg: C('Gray / Light / 1'), pos: 'right'}} />
        <CenterElement />
      </Element>
      <Element
        {...{
          config: {
            position: {
              bottom: 18,
              left: 18,
            },
            width: 72,
            height: 72,
            borderRadius: scale(3.4),
            border: {
              borderRadius: scale(3.4),
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: C('Gray / Light / 4'),
            },
            backgroundColor: C('Overlay / Dark / Picture white'),
          },
        }}>
        <LineElement {...{bg: C('Gray / Light / 1'), pos: 'top'}} />
        <LineElement {...{bg: C('Link / Light / Blue'), pos: 'left'}} />
        <LineElement {...{bg: C('Link / Light / Blue'), pos: 'bottom'}} />
        <LineElement {...{bg: C('Gray / Light / 1'), pos: 'right'}} />
        <CenterElement />
      </Element>
      <Element
        {...{
          config: {
            position: {
              bottom: 18,
              right: 18,
            },
            width: 72,
            height: 72,
            borderRadius: scale(3.4),
            border: {
              borderRadius: scale(3.4),
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: C('Gray / Light / 4'),
            },
            backgroundColor: C('Overlay / Dark / Picture white'),
          },
        }}>
        <LineElement {...{bg: C('Gray / Light / 1'), pos: 'top'}} />
        <LineElement {...{bg: C('Gray / Light / 1'), pos: 'left'}} />
        <LineElement {...{bg: C('Link / Light / Blue'), pos: 'bottom'}} />
        <LineElement {...{bg: C('Link / Light / Blue'), pos: 'right'}} />
        <CenterElement />
      </Element>
      <Element
        {...{
          config: {
            position: {
              top: 162,
              right: 18,
            },
            width: 72,
            height: 72,
            borderRadius: scale(3.4),
            border: {
              borderRadius: scale(3.4),
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: C('Gray / Light / 4'),
            },
            backgroundColor: C('Overlay / Dark / Picture white'),
          },
        }}>
        <LineElement {...{bg: C('Link / Light / Blue'), pos: 'top'}} />
        <LineElement {...{bg: C('Gray / Light / 1'), pos: 'left'}} />
        <LineElement {...{bg: C('Gray / Light / 1'), pos: 'bottom'}} />
        <LineElement {...{bg: C('Link / Light / Blue'), pos: 'right'}} />
        <CenterElement />
      </Element>
      <Element
        {...{
          config: {
            position: {
              top: 252,
              bottom: 252,
              right: 432,
              left: 432,
            },
            borderRadius: scale(80),
            border: {
              borderRadius: scale(80),
              borderColor: C('Gray / Light / 4'),
              borderWidth: scale(1),
            },
          },
          configMobile: {
            position: {
              left: 72,
              right: 72,
              top: 212,
              bottom: 212,
            },
          },
        }}>
        <Element
          {...{
            config: {
              width: 20,
              height: 2,
              position: {
                right: 15,
              },
              verticalCenter: 0,
              parentWidth: bigRectangleSize.w,
              parentHeight: bigRectangleSize.h,
              backgroundColor: C('Link / Light / Blue'),
            },
          }}
        />
        <Element
          {...{
            config: {
              width: 20,
              height: 2,
              position: {
                left: 15,
              },
              verticalCenter: 0,
              parentWidth: bigRectangleSize.w,
              parentHeight: bigRectangleSize.h,
              backgroundColor: C('Link / Light / Blue'),
            },
          }}
        />
        <Element
          {...{
            config: {
              width: 2,
              height: 20,
              position: {
                top: 15,
              },
              horizontalCenter: 0,
              parentWidth: bigRectangleSize.w,
              parentHeight: bigRectangleSize.h,
              backgroundColor: C('Link / Light / Blue'),
            },
          }}
        />
        <Element
          {...{
            config: {
              width: 2,
              height: 20,
              position: {
                bottom: 15,
              },
              horizontalCenter: 0,
              parentWidth: bigRectangleSize.w,
              parentHeight: bigRectangleSize.h,
              backgroundColor: C('Link / Light / Blue'),
            },
          }}
        />
      </Element>
      <Element
        {...{
          config: {
            position: {
              left: '43.33%',
              right: '43.33%',
              top: '40%',
              bottom: '40%',
            },
            borderRadius: scale(6.9),
            border: {
              borderRadius: scale(6.9),
              borderColor: C('Gray / Light / 4'),
              borderWidth: scale(1),
            },
          },
          configMobile: {
            position: {
              left: '30%',
              right: '30%',
              top: '38.75%',
              bottom: '38.75%',
            },
          },
        }}>
        <View
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: C('Overlay / Dark / Picture white'),
          }}>
          <Element
            {...{
              config: {
                width: 20,
                height: 2,
                position: {
                  right: 10,
                },
                verticalCenter: 0,
                parentWidth: medRectangleSize.w,
                parentHeight: medRectangleSize.h,
                backgroundColor: C('Gray / Light / 1'),
              },
            }}
          />
          <Element
            {...{
              config: {
                width: 20,
                height: 2,
                position: {
                  left: 10,
                },
                verticalCenter: 0,
                parentWidth: medRectangleSize.w,
                parentHeight: medRectangleSize.h,
                backgroundColor: C('Gray / Light / 1'),
              },
            }}
          />
          <Element
            {...{
              config: {
                width: 2,
                height: 20,
                position: {
                  top: 10,
                },
                horizontalCenter: 0,
                parentWidth: medRectangleSize.w,
                parentHeight: medRectangleSize.h,
                backgroundColor: C('Gray / Light / 1'),
              },
            }}
          />
          <Element
            {...{
              config: {
                width: 2,
                height: 20,
                position: {
                  bottom: 10,
                },
                horizontalCenter: 0,
                parentWidth: medRectangleSize.w,
                parentHeight: medRectangleSize.h,
                backgroundColor: C('Gray / Light / 1'),
              },
            }}
          />
        </View>
      </Element>
      <Element
        {...{
          config: {
            width: 72,
            height: 72,
            verticalCenter: 0,
            horizontalCenter: 0,
            borderRadius: scale(6.9),
            border: {
              borderRadius: scale(6.9),
              borderColor: C('Gray / Light / 4'),
              borderWidth: scale(1),
            },
          },
        }}>
        <View
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: C('Overlay / Dark / Picture white'),
          }}>
          <Element
            {...{
              config: {
                width: 12,
                height: 2,
                position: {
                  right: 5,
                },
                verticalCenter: 0,
                parentWidth: scale(72),
                parentHeight: scale(72),
                backgroundColor: C('Gray / Light / 1'),
              },
            }}
          />
          <Element
            {...{
              config: {
                width: 12,
                height: 2,
                position: {
                  left: 5,
                },
                verticalCenter: 0,
                parentWidth: scale(72),
                parentHeight: scale(72),
                backgroundColor: C('Gray / Light / 1'),
              },
            }}
          />
          <Element
            {...{
              config: {
                width: 2,
                height: 12,
                position: {
                  top: 5,
                },
                horizontalCenter: 0,
                parentWidth: scale(72),
                parentHeight: scale(72),
                backgroundColor: C('Gray / Light / 1'),
              },
            }}
          />
          <Element
            {...{
              config: {
                width: 2,
                height: 12,
                position: {
                  bottom: 5,
                },
                horizontalCenter: 0,
                parentWidth: scale(72),
                parentHeight: scale(72),
                backgroundColor: C('Gray / Light / 1'),
              },
            }}
          />
        </View>
      </Element>
      <Element
        {...{
          config: {
            width: 28,
            height: 28,
            horizontalCenter: 0,
            verticalCenter: 0,
            borderRadius: scale(3),
            border: {
              borderStyle: 'dashed',
              borderWidth: StyleSheet.hairlineWidth,
              borderRadius: scale(3),
              borderColor: C('Gray / Light / 4'),
            },
          },
        }}
      />
      <Element
        {...{
          config: {
            width: 2,
            height: 20,
            horizontalCenter: 0,
            verticalCenter: 0,
            backgroundColor: C('Link / Light / Blue'),
          },
        }}
      />
      <Element
        {...{
          config: {
            width: 20,
            height: 2,
            horizontalCenter: 0,
            verticalCenter: 0,
            backgroundColor: C('Link / Light / Blue'),
          },
        }}
      />
    </ElementBox>
  );
};

export default ColorWrapper(WrappContent);
